import React from "react";
import { Modal } from "antd";

export const EditRecurringToken = ({
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
}) => {
  return (
    <div>
      {" "}
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Recurring Token Update</h3>
        <div
          style={{
            marginTop: "1rem",
            maxHeight: "25rem",
            overflow: "scroll",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Token <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="Token Name"
              name="token"
              value={data && data.token}
              id="token"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
            />
          </div>
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.token}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
